import request from '@/utils/request'

/**
 *获取员工列表
 * @param {*} data 
 */
export function getCustomerList(data){
    return request({
        url: '/user/list',
        method: 'post',
        data
    })
}

/**
 *修改员工
 * @param {*} data 
 */
export function updateUserInfo(data){
    return request({
        url: '/user/updateUserInfo',
        method: 'post',
        data
    })
}

/**
 *删除员工
 * @param {*} data 
 */
export function del(data){
    return request({
        url: '/user/delete',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/api/customer.js